import React from 'react';
import styles from './SearchBox.module.css';

const SearchBox = ({
  searchValue,
  setSearchValue,
  onSearch,
  onAiSearch,
  isAiSearch = false,
  loading = false,
}) => {
  return (
    <div className={styles.searchBarWrapper}>
      <div className={styles.inputWrapper}>
        <input
          className={styles.input}
          type="text"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          placeholder="Type to search videos..."
        />
      </div>

      <div className={styles.buttonsWrapper}>
        <button className={styles.searchBtn} 
		onClick={onSearch}
		disabled={loading} 
		>
          Search
        </button>
        <button
          className={`${styles.aiSearchBtn} ${isAiSearch ? styles.active : ''}`}
          onClick={onAiSearch}
		  disabled={loading} 
        >
          AI Search
        </button>
      </div>

      {loading && isAiSearch && (
        <p className={styles.loadingText}>AI search might take a bit longer...</p>
      )}
    </div>
  );
};

export default SearchBox;
